"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["addAddressFeedback"] = "addAddressFeedback";
  TranslationKey["cancel"] = "cancel";
  TranslationKey["cannotUpdate"] = "cannotUpdate";
  TranslationKey["confirmEmailDelete"] = "confirmEmailDelete";
  TranslationKey["currentEmail"] = "currentEmail";
  TranslationKey["currentEmailTitle"] = "currentEmailTitle";
  TranslationKey["delete"] = "delete";
  TranslationKey["deleteEmail"] = "deleteEmail";
  TranslationKey["deletedFeedback"] = "deletedFeedback";
  TranslationKey["disabledVerificationEmail"] = "disabledVerificationEmail";
  TranslationKey["edit"] = "edit";
  TranslationKey["editAddressFeedback"] = "editAddressFeedback";
  TranslationKey["emailAnnotation"] = "emailAnnotation";
  TranslationKey["emailConfirmationNeeded"] = "emailConfirmationNeeded";
  TranslationKey["emailPlaceholder"] = "emailPlaceholder";
  TranslationKey["emailTitle"] = "emailTitle";
  TranslationKey["emailToConfirm"] = "emailToConfirm";
  TranslationKey["enterEmailTitle"] = "enterEmailTitle";
  TranslationKey["errorOccured"] = "errorOccured";
  TranslationKey["infoConfirmDialog"] = "infoConfirmDialog";
  TranslationKey["newEmail"] = "newEmail";
  TranslationKey["orderInformation"] = "orderInformation";
  TranslationKey["pendingEmail"] = "pendingEmail";
  TranslationKey["pendingEmailTitle"] = "pendingEmailTitle";
  TranslationKey["save"] = "save";
  TranslationKey["sendAgain"] = "sendAgain";
  TranslationKey["validationEmailTerminatedCustomer"] = "validationEmailTerminatedCustomer";
  TranslationKey["validationLength"] = "validationLength";
  TranslationKey["validationRegex"] = "validationRegex";
  TranslationKey["validationRegexEmail"] = "validationRegexEmail";
  TranslationKey["validationRequired"] = "validationRequired";
  TranslationKey["validationUniqueEmail"] = "validationUniqueEmail";
  TranslationKey["verifiedFeedback"] = "verifiedFeedback";
  TranslationKey["waitingConfirmationEmail"] = "waitingConfirmationEmail";
  return TranslationKey;
}({});
//# sourceMappingURL=TranslationKey.js.map